import React, { ElementRef, FormEventHandler, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

import { Cookie } from "@utils/Cookie";
import { onSubmitDripForm } from "./sfd-helpers/submit-drip-form";
import { signUpDripStepCompleted } from "@utils/signUpDripStepCompleted";
import { StringParam, useQueryParam } from "use-query-params";
import { useFormData } from "@sp-state/useFormData";
import { useSignupFormDrip } from "@sp-state/useSignupFormDrip";
import SignUpLoading from "../../../../Loadings/SignUpLoading/SignUpLoading";
import FormFields from "../FormFields";

import styles from "./Form.module.scss";
import { useKount } from "@hooks/useKount";

const Form = () => {
  const {
    allowNext,
    getCurrentStep,
    getIsLastStep,
    next,
    currentStep,
    startTime,
    lastStepCta,
  } = useSignupFormDrip(state => state);

  const [submittingForm, setSubmittingForm] = useState(false);
  const recaptchaRef = useRef<ElementRef<typeof ReCAPTCHA>>(null);
  const { getDataForSubmission, offerPromoCode } = useFormData(state => state);
  const kountSessionId = useKount();

  const step = getCurrentStep();
  const lastStep = getIsLastStep();
  const btnTxt = lastStep ? lastStepCta : "Continue";

  /* For Submit form */
  const [clickedPlan] = useQueryParam("plan", StringParam);

  const handleSubmit: FormEventHandler<HTMLFormElement> = e => {
    e.preventDefault();

    if (allowNext && !lastStep) {
      next();
      return;
    }

    setSubmittingForm(true);

    const finalTime = Math.floor((Date.now() - startTime) / 1000);

    const formData = {
      ...getDataForSubmission(),
      clickedPlan,
      kountSessionId,
    };

    if (offerPromoCode && lastStep) {
      Cookie.deleteCookieFromBaseDomain("PROMOCODE");
      Cookie.setCookie("PROMOCODE", offerPromoCode, 365);
    }

    onSubmitDripForm({
      formData,
      recaptchaRef,
      finalTime,
    }).finally(() => {
      setSubmittingForm(false);

      signUpDripStepCompleted({
        fields: step?.fields,
        step: currentStep + 1,
        promoCode: (lastStep && offerPromoCode) || "",
      });
    });
  };

  return (
    <form className={styles.formWrapper} onSubmit={handleSubmit}>
      <FormFields fields={step?.fields} />

      {process.env.GATSBY_ENVIRONMENT !== "dev" && (
        <ReCAPTCHA
          sitekey={process.env.GATSBY_GRECAPTCHA_SITE_KEY!}
          ref={recaptchaRef}
          size="invisible"
        />
      )}
      <button
        className={styles.formCta}
        disabled={!allowNext || submittingForm}
        type="submit"
      >
        {submittingForm && (
          <SignUpLoading
            customClass={false}
            overrideClass="signUpLoadingForm"
          />
        )}
        {btnTxt}
      </button>
    </form>
  );
};

export default Form;
